<nz-layout>
  <nz-header nz-row nzJustify="space-between" nzAlign="middle">
    <div nz-col nzFlex="initial">
      <nz-space>
        <button *nzSpaceItem nz-button nzType="default" (click)="back()">
          <i nz-icon nzType="left" nzTheme="outline"></i>
          {{ 'calendar.calendarTitle' | translate }}
        </button>

        <beautyapp-datepicker
          *nzSpaceItem
          style="margin-top: 16px"
          [(ngModel)]="currentDate"
          (ngModelChange)="changeDate($event)"
          [allowClear]="false"
        ></beautyapp-datepicker>
        <nz-space-compact *nzSpaceItem>
          <button nz-button nzType="default" (click)="prevDate()">
            <i nz-icon nzType="left" nzTheme="outline"></i>
          </button>
          <button
            nz-button
            nzType="default"
            (click)="currenDate()"
            >
            <i nz-icon nzType="carry-out" nzTheme="outline"></i>
          </button>
          <button nz-button nzType="default" (click)="nextDate()">
            <i nz-icon nzType="right" nzTheme="outline"></i>
          </button>
        </nz-space-compact>
      </nz-space>
    </div>
    <div nz-col nzFlex="auto">
      <div nz-row nzAlign="middle" nzJustify="center">
        <h4 nz-typography >{{ user.fullName}}</h4>
      </div>

    </div>

    <div nz-col nzFlex="initial">
      <nz-space>
        <!-- beaut-365: day-form slot granularity selector -->
        <nz-space-compact *nzSpaceItem>
          <button
            nz-button
            [nzType]="timeInterval === '00:05:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:05:00')"
          >5 {{ 'calendar.minute' | translate }}.</button>
          <button
            nz-button
            [nzType]="timeInterval === '00:15:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:15:00')"
          >15 {{ 'calendar.minute' | translate }}.</button>
          <button
            nz-button
            [nzType]="timeInterval === '00:20:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:20:00')"
          >20 {{ 'calendar.minute' | translate }}.</button>
          <button
            nz-button
            [nzType]="timeInterval === '00:30:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('00:30:00')"
          >30 {{ 'calendar.minute' | translate }}.</button>
          <button
            nz-button
            [nzType]="timeInterval === '01:00:00' ? 'primary' : 'default'"
            (click)="changeTimeInterval('01:00:00')"
          >1{{ 'calendar.hours' | translate }}.</button>
        </nz-space-compact>
        <nz-space-compact *nzSpaceItem>
          <button nz-button nzType="primary" (click)="dayGridChange('timeGrid')">
            1 {{ 'calendar.day' | translate }}
          </button>
          <button
            nz-button
            nzType="primary"
            (click)="dayGridChange('timeGridSevenDays')"
            >
            7 {{ 'calendar.day' | translate }}
          </button>
        </nz-space-compact>
      </nz-space>
    </div>
  </nz-header>
  <nz-content>
    <full-calendar #calendar [options]="calendarOptions">

      <ng-template #eventContent let-event>
        @if (event.event.extendedProps.content !== 'DayOff') {
          <ng-template #popContent>
            <div class="booking-popup">
              <div><b>{{'calendar.popup.employee' | translate}}:</b> {{event.event.extendedProps.employeeName}}</div>
              <div><b>{{'calendar.popup.user' | translate}}:</b> {{event.event.extendedProps.fullName}}</div>
              <div><b>{{'calendar.popup.mobilePhone' | translate}}:</b> {{event.event.extendedProps.mobilePhone}}</div>
              <div><b>{{'calendar.popup.procedure' | translate}}:</b> {{event.event.extendedProps.services}}</div>
              <div><b>{{'calendar.popup.price' | translate}}:</b> {{event.event.extendedProps.price}} GEL</div>
              @if (event.event.extendedProps.salePrice) {
                <div><b>{{'calendar.popup.discount' | translate}}:</b> {{event.event.extendedProps.salePrice}}</div>
              }
              <div><b>{{'calendar.popup.times' | translate}}:</b> {{(event.event.start | date : 'HH:mm') + ' - ' + (event.event.end | date : 'HH:mm')}}</div>
              @if (event.event.extendedProps.description) {
                <div><b>{{'calendar.popup.comment' | translate}}:</b> {{event.event.extendedProps.description}}</div>
              }
              <div><b>{{'calendar.popup.bookedAt' | translate}}:</b> {{event.event.extendedProps.createdAt | date: 'dd/MM/yyyy HH:mm'}}</div>
              <div><b>{{'calendar.popup.bookedBy' | translate}}:</b> {{event.event.extendedProps.createdBy}}</div>
              @if (event.event.extendedProps.completedBy) {
                <div><b>{{'calendar.popup.completedBy' | translate}}:</b> {{event.event.extendedProps.completedBy}}</div>
              }
            </div>
          </ng-template>
          <div
            nz-popover
            [nzPopoverTitle]="(event.event.extendedProps.bookingDate | date:'dd/MM/yyyy') +' - '+(event.event.start | date : 'HH:mm') + '-' + (event.event.end | date : 'HH:mm')"
            [nzPopoverContent]="popContent"
            nzPopoverPlacement="topLeft"
            class="book-event"
            >
            <div>
              @if (event.event?.extendedProps.visitStatus) {
                @switch (event.event.extendedProps.visitStatus) {
                  @case ('CONFIRMED') {
                    <span nz-icon nzType="check-circle" nzTheme="outline" nz-tooltip="დასტურებული"></span>
                  }
                  @case ('IN_PROGRESS') {
                    <span nz-icon nzType="clock-circle" nzTheme="outline" nz-tooltip="პროცესში"></span>
                  }
                  @case ('COMPLETED') {
                    <span nz-icon nzType="lock" nzTheme="fill" nz-tooltip="დასრულებული"></span>
                  }
                  @case ('NO_SHOW') {
                    <span nz-icon nzType="user-delete" nzTheme="outline" nz-tooltip="არ გამოცხადდა"></span>
                  }
                  @case ('NEED_CALL') {
                    <span nz-icon nzType="phone" nzTheme="outline" nz-tooltip="დასარეკია"></span>
                  }
                }
              } @else if (event.event?.extendedProps.status === 2) {
                <span nz-row nz-icon nzType="lock" nzTheme="fill"></span>
              }
              @if (event.event?.extendedProps.onUserRequest) {
                <span
                  nz-row
                  nz-icon
                  nzType="star"
                  nzTheme="fill"
                ></span>
              }
              @if (event.event?.display === 'background') {
                <span
                  nz-row
                  nz-icon
                  nzType="clock-circle"
                  nzTheme="fill"
                ></span>
              }
            </div>
            <div>
              <div class="fc-event-title">
                <div class="fc-event-title__name">
                  {{ event.event?.title }}
                  {{ event.event.extendedProps?.mobilePhone }}
                </div>
                <div class="fc-event-title__time">
                  {{ event.event.start | date : 'HH:mm' }} -
                  {{ event.event.end | date : 'HH:mm' }}
                </div>
              </div>
            </div>
          </div>
        } @else {
          <div
            class="book-event"
            >
            <div>
              @if (event.event?.display === 'background') {
                <span
                  nz-row
                  nz-icon
                  nzType="clock-circle"
                  nzTheme="fill"
                ></span>
              }
            </div>
            <div>
              <div class="fc-event-title">
                <div class="fc-event-title__name">
                  {{ event.event?.title }}
                </div>
              </div>
            </div>
          </div>
        }
      </ng-template>
    </full-calendar>
  </nz-content>
</nz-layout>
<!--<div #popoverElementRef class="tooltip" role="tooltip"></div>-->
